import { Controller } from "@hotwired/stimulus"
import { trackEvent } from "../analytics"

// Reports `send_message.started` the first time the prospect puts content into
// the contact form (one-step or two-step). This is the form-agnostic
// intermediate funnel signal between viewing an advocate and sending a message —
// the one-step form has no server round-trip to instrument, so it can only be
// captured client-side. Fires on the first `input` (typing in name / phone /
// message), deduped per advocate per session so the rate-limited ingestion
// endpoint isn't spammed across Turbo re-renders (e.g. two-step Back → Continue).
//
// Example usage:
//   <div data-controller="send-message-started"
//        data-action="input->send-message-started#start"
//        data-send-message-started-advocate-id-value="123"></div>
export default class extends Controller {
  static values = { advocateId: Number }

  start() {
    if (this.fired) return
    this.fired = true

    if (this.alreadyReported()) return
    this.markReported()

    trackEvent("send_message.started", { advocate_id: this.advocateIdValue })
  }

  storageKey() {
    return `send-message-started:${this.advocateIdValue}`
  }

  alreadyReported() {
    try {
      return sessionStorage.getItem(this.storageKey()) === "1"
    } catch {
      return false
    }
  }

  markReported() {
    try {
      sessionStorage.setItem(this.storageKey(), "1")
    } catch {
      // sessionStorage unavailable (private mode quota) — fall back to the
      // per-connect this.fired guard.
    }
  }
}
